<template>
    <div>
        <suggestion-planes  v-if="fromAirport || toAirport" :fromAirport=fromAirport :toAirport=toAirport />
        <p :class="{'trip': !plane}" v-if="fromAirport || toAirport">
            {{ $t('registration.flight-suggestions-title') }}
            {{ fromAirport ? `${fromAirport.nomAeroport} (${fromAirport.IATA ? fromAirport.IATA : fromAirport.OACI})` : '' }}
            {{ toAirport ? ' -> ' : '' }}
            {{ toAirport ? `${toAirport.nomAeroport} (${toAirport.IATA ? toAirport.IATA : toAirport.OACI})` : '' }}
        </p>
    </div>
</template>

<script>
import SuggestionPlanes from './suggestion-planes';
export default {
    components: { SuggestionPlanes },
    props: {
        planeString: {
            type: String
        },
        fromAirportString: {
            type: String
        },
        toAirportString: {
            type: String
        }
    },
    data() {
        return {
            entityLegalStatus: "professional",
        };
    },
    computed: {
        plane() {
            if (!this.planeString) {
                return;
            }

            return JSON.parse(this.planeString);
        },
        fromAirport() {
            if (!this.fromAirportString) {
                return;
            }

            return JSON.parse(this.fromAirportString);
        },
        toAirport() {
            if (!this.toAirportString) {
                return;
            }

            return JSON.parse(this.toAirportString);
        },
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/legs.vue